export default __webpack_public_path__ + "static/media/i-speedometer_bcr.578cb6a6.svg";